import { Fragment, useEffect, useReducer, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { notificationActions } from "../../../store/notification-slice";
import useFetch from "../../../hook/useFetch";
import { userActions } from "../../../store/user-slice";
import $ from 'jquery'
import ToggleButton from "../../ToggleButton";
import parse from 'html-react-parser';
import useIsMobile from '../../../hook/useIsMobile';
import Order from "./edituser/order";
import ResetLinks from "./edituser/resetlinks";


export default function EditUser(props) {
    const { id } = props

    let users = useSelector(state => state.user.users)

    const reducer = (state, action) => {
        switch (action.type) {
            case 'TOGGLE_MODAL':
                return { ...state, mountModal: !state.mountModal }
            case 'MODAL_DATA':
                return { ...state, modalData: action.data }

            case 'editedUser':
                return { ...state, editedUser: action.data }
            case 'email':
                return { ...state, email: action.data }
            case 'password':
                return { ...state, password: action.data }
            case 'confirmation_password':
                return { ...state, confirmation_password: action.data }
            case 'username':
                return { ...state, username: action.data }
            case 'is_admin':
                return { ...state, is_admin: action.data }
            case 'activated':
                return { ...state, activated: action.data }


        }
    }


    const [componentState, componentDispatch] = useReducer(reducer, {
        mountModal: false,
        modalData: null,

        editedUser: null,
        email: null,
        password: null,
        confirmation_password: null,
        username: null,
        is_admin: null,
        activated: null
    })


    let dispatch = useDispatch()

    const { update, error } = useFetch()

    let token = useSelector(state => state.user.token)
  
    let navigate = useNavigate()


    useEffect(() => {

        if (users) {
            let user = false
            Object.keys(users).forEach(key => {

                if (users[key].id == id) {
                    user = users[key]

                }

            })

            componentDispatch({
                type: 'editedUser',
                data: user
            })
           
        }


    }, [users])

    useEffect(() => {
        if (componentState && componentState.editedUser === false) {
            dispatch(notificationActions.setNotification({
                message: `user with id: ${id} not found`,
                status: false
            }))

        }


    }, [componentState])

    const { isMobile } = useIsMobile()


    if (componentState && componentState.editedUser === null) {
        return <Skeleton count={50} />
    }

    return <Fragment>{componentState && componentState.editedUser && <div className={`details-container ${isMobile ? 'container' : 'grid-container-2-col'}`} >


        <div className="left-col bg-white" >
            <form onSubmit={(e) => {
                e.preventDefault()



                update(`/admin/update-data?token=${token}`, {
                    username: componentState.username,
                    email: componentState.email,
                    password: componentState.password,
                    confirmation_password: componentState.confirmation_password,
                    is_admin: componentState.is_admin,
                    id,
                    activated: componentState.activated

                }, null, () => {

                    dispatch(notificationActions.setNotification({
                        message: `user updated`,
                        status: true
                    }))


                    navigate('/admin/users',{
                        state:{
                            refetch:true
                        }
                    })
                })
            }} >

                {error &&
                    <div className="alert bg-danger " >
                        <p>{parse(error)}</p>
                    </div>
                }

                <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Username</label>
                    <input type="text" className="form-control" placeholder="Username" defaultValue={componentState.editedUser.username} onInput={(e) => {
                        componentDispatch(
                            {
                                type: 'username',
                                data: e.target.value
                            }
                        )
                    }} required />

                </div>
                <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Email address</label>
                    <input type="email" className="form-control" placeholder="Email" defaultValue={componentState.editedUser.email} onInput={(e) => {
                        componentDispatch(
                            {
                                type: 'email',
                                data: e.target.value
                            }
                        )
                    }} required />

                </div>
                <div className="form-group">
                    <label htmlFor="exampleInputPassword1">Password</label>
                    <input type="password" className="form-control" placeholder="Password" onInput={(e) => {
                        componentDispatch(
                            {
                                type: 'password',
                                data: e.target.value
                            }
                        )
                    }} />
                </div>

                <div className="form-group">
                    <label htmlFor="exampleInputPassword1">Password Confirmation</label>
                    <input type="password" className="form-control" placeholder="Password Confirmation" onInput={(e) => {
                        componentDispatch(
                            {
                                type: 'confirmation_password',
                                data: e.target.value
                            }
                        )
                    }} />
                </div>

                <div style={{ display: `${!isMobile ? 'flex' : ''}` }}>

                    <ToggleButton onToggle={(e) => {

                        componentDispatch(
                            {
                                type: 'is_admin',
                                data: $(e.target).is(':checked')
                            }
                        )
                    }}
                        id='isadmin'
                        label='IsAdmin'
                        defaultChecked={componentState.editedUser.is_admin}
                    />

                    <ToggleButton onToggle={(e) => {

                        componentDispatch(
                            {
                                type: 'activated',
                                data: $(e.target).is(':checked')
                            }
                        )
                    }}
                        id='activated'
                        label='Activated'
                        defaultChecked={componentState.editedUser.activated}
                    />

                </div>


                <button type="submit" className="btn btn-primary" >Update</button>

            </form>

            <ResetLinks user={componentState.editedUser} />
        </div>
        
        <Order orders={componentState.editedUser.orders} user={componentState.editedUser} />
        


    </div>}</Fragment>
}